import React, { useState } from 'react';
import { ChatSparkle24Regular, ChatSparkle24Filled } from '@fluentui/react-icons';
import { Box } from '../../../../theme/fluent';
import { useAppLayoutStyles } from '../../AppLayout.styles';
import { INavigationItem } from '../../AppLayout.types';
import { CollapseButton } from '../collapse-button';
import { NavigationFooter } from '../navigation-footer';
import { NavigationItems } from '../navigation-items';
import { SimpleNavItem } from '../navigation-items/NavigationItems.types';
import { useChatPanelState } from '../../../../providers';
import { chatFeatureFlags } from '../../../../config';

const DRAWER_WIDTH = 240;
const DRAWER_WIDTH_COLLAPSED = 64;

interface SidebarProps {
    dashboardItem: SimpleNavItem | undefined;
    customShortcuts: INavigationItem[];
    otherNavigationItems: SimpleNavItem[];
}

export const Sidebar: React.FC<SidebarProps> = ({ dashboardItem, customShortcuts, otherNavigationItems }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    const { classes, pureWhiteColor } = useAppLayoutStyles();
    const { isChatMinimized, toggleChatPanel } = useChatPanelState();
    const currentDrawerWidth = isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

    const isChatActive = !isChatMinimized;

    const handleToggle = () => {
        setIsCollapsed(!isCollapsed);
    };

    return (
        <Box className={classes.sideNav} style={{ width: `${currentDrawerWidth}px` }}>
            <CollapseButton isCollapsed={isCollapsed} pureWhiteColor={pureWhiteColor} onToggle={handleToggle} />

            <NavigationItems
                dashboardItem={dashboardItem}
                customShortcuts={customShortcuts}
                otherNavigationItems={otherNavigationItems}
                isCollapsed={isCollapsed}
            />

            {/* Chat Toggle Icon - positioned at bottom of toolbar */}
            {chatFeatureFlags.sidebarChatToggle && (
            <Box className={classes.chatToggleSection}>
                <Box
                    onClick={toggleChatPanel}
                    className={classes.chatToggleIcon}
                >
                    {isChatActive ? (
                        <ChatSparkle24Filled
                            style={{
                                color: '#FFFFFF',
                                width: '20px',
                                height: '20px',
                            }}
                        />
                    ) : (
                        <ChatSparkle24Regular
                            style={{
                                color: 'rgba(255, 255, 255, 0.6)',
                                width: '20px',
                                height: '20px',
                            }}
                        />
                    )}
                </Box>
            </Box>
            )}

            <NavigationFooter isCollapsed={isCollapsed} />
        </Box>
    );
};
